import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { SellerDetailComponent } from '../seller-detail/seller-detail.component';
import { HttpParams } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { SellerDetail } from '../seller.model';

@Component({
  selector: 'app-seller-manage',
  templateUrl: './seller-manage.component.html',
  styleUrls: ['./seller-manage.component.scss']
})
export class SellerManageComponent implements OnInit {
  username = localStorage.getItem('username');

  searchName: string;
  searchTaxID: string;

  searchingName: boolean = false;
  searchingTaxID: boolean = false;
  loading = false;

  sellerDetails: SellerDetail[] = [];
  sellerNames: string[] = [];
  sellerTaxIDs: string[] = [];

  constructor(
    private apiService: ApiService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;

    this.apiService.getSellerBranch()
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        (res: SellerDetail[]) => {
          this.sellerDetails = res;

          this.setSellerNames();
          this.setSellerTaxIDs();
        }
      );
  }

  setSellerNames() {
    this.sellerNames = this.sellerDetails.map(seller => seller.name_th);
    // Make it unique
    this.sellerNames = this.sellerNames.filter((value, index, array) => array.indexOf(value) === index);
  }

  setSellerTaxIDs() {
    this.sellerTaxIDs = this.sellerDetails.map(seller => seller.tax_id);
    // Make it unique
    this.sellerTaxIDs = this.sellerTaxIDs.filter((value, index, array) => array.indexOf(value) === index);
  }

  search() {
    let params = new HttpParams();
    if (this.searchName) {
      params = params.append('name', this.searchName);
    }

    if (this.searchTaxID) {
      params = params.append('tax_id', this.searchTaxID);
    }

    this.loading = true;

    this.apiService.getSellerBranch(params)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        (res: SellerDetail[]) => {
          this.sellerDetails = res;
        }
      );
  }

  clearSearch() {
    this.searchName = null;
    this.searchTaxID = null;
    this.search();
  }

  openModal(sellerDetail: SellerDetail) {
    const modal = this.modalService.open(SellerDetailComponent, { backdrop: 'static', centered: true, windowClass: 'seller-detail-modal' });
    const modalContent = modal.componentInstance;

    modalContent.sellerDetail = sellerDetail;

    modal.result.then(result => {
      if (result) {
        this.loadData();
      }
    });
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/seller-manage/seller-manage.component.ts